"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _ConfirmModal = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/ConfirmModal"));
var _modals = require("../../../utils/modals");
var ConfirmPublishModal = function ConfirmPublishModal(_ref) {
  var onPublishConfirm = _ref.onPublishConfirm;
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var onCancel = function onCancel() {
    return closeModal();
  };
  var onConfirm = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            _context.next = 3;
            return onPublishConfirm(closeModal);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onConfirm() {
      return _ref2.apply(this, arguments);
    };
  }();
  var bodyText = "When you publish, any changes in the current version you are editing are saved and overwrite the asset's published portal.";
  var body = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, bodyText));
  return /*#__PURE__*/_react.default.createElement(_ConfirmModal.default, {
    testId: "publish-portal-draft-modal",
    title: "Confirm portal publication",
    body: body,
    isLoading: isLoading,
    onCancel: onCancel,
    confirmButtonText: "Publish",
    onConfirm: onConfirm
  });
};
var ConfirmPublishModalContainer = (0, _modals.setModalName)('ConfirmPublishModal')(ConfirmPublishModal);
var _default = exports.default = ConfirmPublishModalContainer;
//# sourceMappingURL=ConfirmPublishModal.js.map